module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/contact-collector-panel-mobile-d6057b2f6def09efa227e8970dc545c2.jpg";